import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ChequeService } from "../shared/cheque.service";
import { PrivilegeService } from "../../../staff/Shared/privilege.service";
import { Document } from "./../../../helpers/Document";

@Component({
  selector: 'app-chequelist',
  templateUrl: './chequelist.component.html',
  styleUrls: ['./chequelist.component.css']
})

export class ChequelistComponent implements OnInit {

  displayedColumns: string[] = ['ChequeNo', 'BankName', 'IssueDate', 'PassDate', 'CancelDate', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  IsAdd : boolean;
  IsEdit : boolean;
  IsDelete : boolean;
  IsView : boolean;
  IsPrint : boolean;

  constructor(private router: Router, private chequeService: ChequeService,
    private privilegeService: PrivilegeService) {

    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {

    // Getting page permissions
    const DocumentId = Document.CheckList;
    this.PageSecurity(DocumentId);
    this.getChequeList();
  }

  getChequeList() {
    this.chequeService.FetchChequeList().subscribe(data => {
      // this.ChequeList$=data;
      this.dataSource.data = data;
    })
  }

  public AddNewCheque() {
    this.router.navigate(['/cheque']);
  }

  EditCheque(chequeNo: any) {
    this.router.navigate(['/cheque', chequeNo.Id]);
  }

  PageSecurity(DocumentId : number){
    
    this.privilegeService.GetPageSecuritybyRoleId(DocumentId).toPromise()
    .then(data => {
              if(data!==null){
                    this.IsAdd = data.IsAdd ;
                    this.IsEdit = data.IsEdit;
                    this.IsDelete = data.IsDelete ;
                    this.IsView = data.IsView ;
                    this.IsPrint = true;
                    console.log(this.IsAdd);
              }
    });
  }
}
